export default __webpack_public_path__ + "static/media/aquasil-geschmack.8fb21089.svg";